import axiosInstance from './axios';
import { token } from './auth';

const baseUrl = '/api';

const setConfig = () => ({
  headers: { 'x-auth-token': token },
});

/**
 * Get all conversations for the authenticated user
 */
const getConversations = async (limit: number = 20, offset: number = 0): Promise<any> => {
  const response = await axiosInstance.get(
    `${baseUrl}/conversations?limit=${limit}&offset=${offset}`,
    setConfig()
  );
  return response.data;
};

/**
 * Create a new DM conversation or get existing one with a user
 */
const createOrGetDM = async (userId: string): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/conversations/dm`,
    { userId },
    setConfig()
  );
  return response.data;
};

/**
 * Get a specific conversation by ID
 */
const getConversation = async (conversationId: string): Promise<any> => {
  const response = await axiosInstance.get(
    `${baseUrl}/conversations/${conversationId}`,
    setConfig()
  );
  return response.data;
};

/**
 * Get messages from a conversation with pagination
 */
const getConversationMessages = async (
  conversationId: string,
  limit: number = 20,
  cursor: string | null = null
): Promise<any> => {
  const params = new URLSearchParams();
  params.append('limit', limit.toString());
  if (cursor) {
    params.append('cursor', cursor);
  }

  const response = await axiosInstance.get(
    `${baseUrl}/conversations/${conversationId}/messages?${params.toString()}`,
    setConfig()
  );
  return response.data;
};

/**
 * Send a message in a conversation
 */
const sendMessage = async (
  conversationId: string,
  text: string,
  attachments: any[] = []
): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/messages`,
    { conversationId, text, attachments },
    setConfig()
  );
  return response.data;
};

/**
 * Mark a conversation as read up to a specific message
 */
const markConversationAsRead = async (
  conversationId: string,
  messageId: string | null = null
): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/conversations/${conversationId}/read`,
    messageId ? { messageId } : {},
    setConfig()
  );
  return response.data;
};

const directMessagesService = {
  getConversations,
  createOrGetDM,
  getConversation,
  getConversationMessages,
  sendMessage,
  markConversationAsRead,
};

export default directMessagesService;
